import { cx } from "@jugl-web/utils";
import { FC } from "react";

export interface LiveChatUIConversationListItemProps {
  title: string;
  isActive?: boolean;
  onClick: () => void;
}

export const LiveChatUIConversationListItem: FC<
  LiveChatUIConversationListItemProps
> = ({ title, isActive, onClick }) => (
  <li>
    <button
      type="button"
      onClick={onClick}
      className={cx(
        "h-8 w-full cursor-pointer truncate rounded-[10px] border-none px-3 text-left font-secondary text-sm leading-[140%] font-normal transition-colors",
        isActive
          ? "bg-grey-100 text-black"
          : "bg-transparent text-[#4F4F4F] hover:bg-grey-100 hover:text-black"
      )}
    >
      {title}
    </button>
  </li>
);
